import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isCashierUser } from '../utils/roleUtils';
import DashboardPage from './DashboardPage';

const HomePage = () => {
  const { user } = useAuth();
  if (isCashierUser(user)) {
    return <Navigate to="/checkout" replace />;
  }
  return <DashboardPage />;
};

export default HomePage;
